import cookieMonster from "../../utilities/js/cookieMonster/cookieMonster";
import "babel-polyfill";

const cookieConsentManager = {
  resolveWithDelay() {
    return new Promise(resolve => {
      setTimeout(() => {
        // https://help.consentmanager.net/books/cmp/page/cmp-events
        // eslint-disable-next-line no-unused-vars
        function getInfos(e,o) {
          // eslint-disable-next-line no-undef
          var result = __cmp('getCMPData');
          // ISIGEPAP-545 if c27812
          if (result.vendorConsents.c27812) {
            cookieMonster.set(btoa(JSON.stringify(cookieMonster.acceptAll())));
          }
          resolve();
        }
        // eslint-disable-next-line no-undef
        __cmp("addEventListener",["consent",getInfos,false],null);
      }, 2000);
    });
  },
  async callConsentManager() {
    try {
      await this.resolveWithDelay();
    } catch (e) {
      // noop
    }
  }
};

export default cookieConsentManager;
